class AnnouncementRotator extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('.announcement-rotator__slide')];
    this.index = 0;
    this.slides.forEach((slide, index) => { slide.hidden = index !== 0; });
    const updateHeight = () => {
      const bar = this.closest('.announcement-bar');
      // Only a sticky bar needs reserved space above the header and search overlay.
      const height = bar.dataset.sticky === 'true' ? bar.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--announcement-height', `${height}px`);
    };
    updateHeight();
    this.sizeObserver = new ResizeObserver(updateHeight);
    this.sizeObserver.observe(this);
    if (this.slides.length < 2) return;
    this.events = new AbortController();
    const options = { signal: this.events.signal };
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.paused = this.motion.matches;
    this.querySelectorAll('[data-announcement-controls]').forEach(control => { control.hidden = false; });
    this.pauseButton = this.querySelector('[data-announcement-pause]');
    // Focus permanently pauses until the customer explicitly resumes rotation.
    this.addEventListener('focusin', () => { this.paused = true; this.updateTimer(); }, options);
    this.addEventListener('mouseenter', () => { this.hovered = true; this.updateTimer(); }, options);
    this.addEventListener('mouseleave', () => { this.hovered = false; this.updateTimer(); }, options);
    // Capture the action before pointer focus automatically pauses rotation.
    this.pauseButton.addEventListener('pointerdown', () => { this.pointerPaused = this.paused; }, options);
    this.pauseButton.addEventListener('pointercancel', () => { this.pointerPaused = undefined; }, options);
    this.pauseButton.addEventListener('click', event => {
      const wasPaused = event.detail > 0 ? this.pointerPaused ?? this.paused : this.paused;
      this.pointerPaused = undefined;
      this.paused = !wasPaused;
      this.updateTimer();
    }, options);
    this.querySelector('[data-announcement-previous]').addEventListener('click', () => this.show(-1), options);
    this.querySelector('[data-announcement-next]').addEventListener('click', () => this.show(1), options);
    this.motion.addEventListener('change', () => {
      if (this.motion.matches) this.paused = true;
      this.updateTimer();
    }, options);
    document.addEventListener('visibilitychange', () => this.updateTimer(), options);
    this.updateTimer();
  }

  show(step) {
    this.slides[this.index].hidden = true;
    this.index = (this.index + step + this.slides.length) % this.slides.length;
    this.slides[this.index].hidden = false;
  }

  updateTimer() {
    clearInterval(this.timer);
    const label = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
    this.pauseButton.setAttribute('aria-label', label);
    this.pauseButton.title = label;
    this.pauseButton.dataset.paused = String(this.paused);
    this.querySelector('.announcement-rotator__inner').setAttribute('aria-live', this.paused ? 'polite' : 'off');
    if (!this.paused && !this.hovered && !document.hidden) this.timer = setInterval(() => this.show(1), 3000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    this.events?.abort();
    this.sizeObserver?.disconnect();
    document.documentElement.style.removeProperty('--announcement-height');
  }
}
if (!customElements.get('announcement-rotator')) customElements.define('announcement-rotator', AnnouncementRotator);
